export const state = {
    invoices: [],
    invoice_items: [
        {
            description: "",
            amount: ""
        }
    ],

    container_details: [
        {
            container_no: ""
        }
    ]
}
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/invoices/state.js